export var Role;
(function (Role) {
    Role[Role["Admin"] = -1] = "Admin";
    Role[Role["Owner"] = 0] = "Owner";
    Role[Role["Manager"] = 1] = "Manager";
    Role[Role["Worker"] = 2] = "Worker";
})(Role || (Role = {}));
export var NominalHoursMode;
(function (NominalHoursMode) {
    NominalHoursMode[NominalHoursMode["WeekFactor"] = 0] = "WeekFactor";
    NominalHoursMode[NominalHoursMode["Exact"] = 1] = "Exact";
    NominalHoursMode[NominalHoursMode["ExactWithoutHolidays"] = 2] = "ExactWithoutHolidays";
    NominalHoursMode[NominalHoursMode["FixedDays"] = 3] = "FixedDays";
    NominalHoursMode[NominalHoursMode["FixedDaysWithoutHolidays"] = 4] = "FixedDaysWithoutHolidays";
    NominalHoursMode[NominalHoursMode["ExactWithoutHolidaysUsingAbsenceHours"] = 5] = "ExactWithoutHolidaysUsingAbsenceHours";
})(NominalHoursMode || (NominalHoursMode = {}));
export var EmploymentType;
(function (EmploymentType) {
    EmploymentType[EmploymentType["Regular"] = 0] = "Regular";
    EmploymentType[EmploymentType["Marginal"] = 1] = "Marginal";
    EmploymentType[EmploymentType["Independent"] = 2] = "Independent";
    EmploymentType[EmploymentType["ShortTerm"] = 3] = "ShortTerm";
    EmploymentType[EmploymentType["Trainee"] = 4] = "Trainee";
    EmploymentType[EmploymentType["MidiJob"] = 5] = "MidiJob";
    EmploymentType[EmploymentType["WorkingStudent"] = 6] = "WorkingStudent";
    EmploymentType[EmploymentType["DualStudent"] = 7] = "DualStudent";
    EmploymentType[EmploymentType["Intern"] = 8] = "Intern";
})(EmploymentType || (EmploymentType = {}));
export var VacationIncrement;
(function (VacationIncrement) {
    VacationIncrement[VacationIncrement["Monthly"] = 0] = "Monthly";
    VacationIncrement[VacationIncrement["Hourly"] = 1] = "Hourly";
})(VacationIncrement || (VacationIncrement = {}));
/**
 * Specifies how breaks are handled for a given shift.
 *
 * See also {@link TimeSettings}, {@link AutoBreak}
 */
//TODO: move to breaks.ts
export var BreakMode;
(function (BreakMode) {
    /** Breaks are calculated according to {@link TimeSettings.autoBreaks} */
    BreakMode[BreakMode["Auto"] = 0] = "Auto";
    /** Breaks are taken directly from time entries */
    BreakMode[BreakMode["Manual"] = 1] = "Manual";
    /** Breaks are calculated by adding manual breaks to automatic breaks */
    BreakMode[BreakMode["AutoPlusManual"] = 2] = "AutoPlusManual";
    /** Breaks are planned as part of a shift */
    BreakMode[BreakMode["Planned"] = 3] = "Planned";
    /** Breaks are calculated by adding manual breaks to planned breaks */
    BreakMode[BreakMode["PlannedPlusManual"] = 4] = "PlannedPlusManual";
    /** Breaks are the maximum of automatic and manual breaks */
    BreakMode[BreakMode["AutoOrManual"] = 5] = "AutoOrManual";
    /** Breaks are the maximum of planned and manual breaks */
    BreakMode[BreakMode["PlannedOrManual"] = 6] = "PlannedOrManual";
})(BreakMode || (BreakMode = {}));
/**
 * Specifies whether a break is deducted from the start or the end of a shift.
 */
//TODO: move to breaks.ts
export var BreakTiming;
(function (BreakTiming) {
    BreakTiming["Start"] = "start";
    BreakTiming["End"] = "end";
})(BreakTiming || (BreakTiming = {}));
export var AbsenceMode;
(function (AbsenceMode) {
    AbsenceMode[AbsenceMode["Average"] = 0] = "Average";
    AbsenceMode[AbsenceMode["Fixed"] = 1] = "Fixed";
    AbsenceMode[AbsenceMode["FixedDays"] = 2] = "FixedDays";
})(AbsenceMode || (AbsenceMode = {}));
export var MealsMode;
(function (MealsMode) {
    MealsMode["Manual"] = "manual";
    MealsMode["Auto"] = "auto";
    MealsMode["Employee"] = "employee";
})(MealsMode || (MealsMode = {}));
export var StaffAppFeature;
(function (StaffAppFeature) {
    StaffAppFeature["Roster"] = "roster";
    StaffAppFeature["Absences"] = "absences";
    StaffAppFeature["Ledgers"] = "ledgers";
    StaffAppFeature["Time"] = "time";
    StaffAppFeature["Tracking"] = "tracking";
})(StaffAppFeature || (StaffAppFeature = {}));
export var Feature;
(function (Feature) {
    Feature["Employees"] = "employees";
    Feature["Roster"] = "roster";
    Feature["Time"] = "time";
    Feature["Revenues"] = "revenues";
    Feature["Planning"] = "planning";
    Feature["StaffApp"] = "staffapp";
    Feature["voiceControlAi"] = "voiceControlAi";
    Feature["PentacodePayroll"] = "pentacodePayroll";
    // Temporary flag that unlocks the AI assistant settings page outside of dev environments
    // Remove once the page is generally available.
    Feature["AiAssistantSettings"] = "aiAssistantSettings";
})(Feature || (Feature = {}));
export var PartnerIntegration;
(function (PartnerIntegration) {
    PartnerIntegration["HorecaHero"] = "horeca_hero";
    PartnerIntegration["Intratool"] = "intratool";
    PartnerIntegration["Onboard"] = "onboard";
    PartnerIntegration["Uberblick"] = "uberblick";
})(PartnerIntegration || (PartnerIntegration = {}));
export const featureFlags = [
    "notificationsPushMobile", //TODO: remove
    "notificationsPushDesktop", //TODO: remove
    "rosterAutoAssign",
    "recruitingUpdate",
    "recruitingDashboardTile",
    "pentacodePayroll",
    "halfDayVacations",
    "ynaEnableNotification",
    "skipAiAssistantLicenseCheck",
    // "Dokumentherkunft": the document-origin filter and origin pills in the employee document views.
    "documentOriginFilter",
    // Lets employees upload their own documents (photo/file) from the staff app.
    "staffDocumentUpload",
    // File attachments in the assistant chat (upload to the conversation file storage).
    "voiceControlAiFiles",
    // Admin company (JSON) import; kept off on prod because it can create unwanted companies.
    "companyImport",
];
export const WorkspaceFilterTypes = ["venue", "department", "position"];
export var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["TrialWithoutContract"] = "trial_without_contract";
    CompanyStatus["Trialing"] = "trialing";
    CompanyStatus["Probation"] = "probation";
    CompanyStatus["Active"] = "active";
    CompanyStatus["Paused"] = "paused";
    CompanyStatus["Canceled"] = "canceled";
    CompanyStatus["PaymentOverdue"] = "payment_overdue";
})(CompanyStatus || (CompanyStatus = {}));
export var InviteStatus;
(function (InviteStatus) {
    InviteStatus["Created"] = "created";
    InviteStatus["Sent"] = "sent";
    InviteStatus["DeliveryFailed"] = "delivery_failed";
    InviteStatus["Rejected"] = "rejected";
    InviteStatus["Accepted"] = "accepted";
})(InviteStatus || (InviteStatus = {}));
export var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["Probation"] = "probation";
    EmployeeStatus["Active"] = "active";
    EmployeeStatus["Retired"] = "retired";
})(EmployeeStatus || (EmployeeStatus = {}));
export var Gender;
(function (Gender) {
    Gender["Male"] = "m";
    Gender["Female"] = "w";
    Gender["NonBinary"] = "d";
    Gender["Undetermined"] = "x";
})(Gender || (Gender = {}));
export var TaxKey;
(function (TaxKey) {
    TaxKey[TaxKey["None"] = 0] = "None";
    TaxKey[TaxKey["Free"] = 1] = "Free";
    TaxKey[TaxKey["Sales7"] = 2] = "Sales7";
    TaxKey[TaxKey["Sales19"] = 3] = "Sales19";
    TaxKey[TaxKey["Input7"] = 8] = "Input7";
    TaxKey[TaxKey["Input19"] = 9] = "Input19";
    TaxKey[TaxKey["Input7_8"] = 350] = "Input7_8";
    TaxKey[TaxKey["Input9_5"] = 408] = "Input9_5";
    // Sales5 = 11,
    // Sales16 = 12,
    // Input5 = 13,
    // Input16 = 14
})(TaxKey || (TaxKey = {}));
export var RevenueType;
(function (RevenueType) {
    RevenueType["Sales"] = "sales";
    RevenueType["Expense"] = "expense";
    RevenueType["Cashless"] = "cashless";
    RevenueType["Debt"] = "debt";
    RevenueType["Deposit"] = "deposit";
    RevenueType["PayAdvance"] = "advance";
    RevenueType["CashCount"] = "cash_count";
    RevenueType["Adjustment"] = "adjustment";
    RevenueType["BankDeposit"] = "bank_deposit";
    RevenueType["Other"] = "other";
})(RevenueType || (RevenueType = {}));
export var AbsenceStatus;
(function (AbsenceStatus) {
    AbsenceStatus["Requested"] = "requested";
    AbsenceStatus["Approved"] = "approved";
    AbsenceStatus["Denied"] = "denied";
    AbsenceStatus["Inferred"] = "inferred";
})(AbsenceStatus || (AbsenceStatus = {}));
export var VacationPolicy;
(function (VacationPolicy) {
    VacationPolicy["AllowAll"] = "allow_all";
    VacationPolicy["DisallowRequests"] = "disallow_requests";
    VacationPolicy["DisallowAll"] = "disallow_all";
})(VacationPolicy || (VacationPolicy = {}));
export var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Available"] = "available";
    AvailabilityStatus["Unavailable"] = "unavailable";
    AvailabilityStatus["Preferred"] = "preferred";
    AvailabilityStatus["Unpreferred"] = "unpreferred";
})(AvailabilityStatus || (AvailabilityStatus = {}));
export var Repeat;
(function (Repeat) {
    Repeat["Never"] = "never";
    Repeat["Weekly"] = "weekly";
    Repeat["Monthly"] = "monthly";
    Repeat["Yearly"] = "yearly";
})(Repeat || (Repeat = {}));
export var MimeType;
(function (MimeType) {
    MimeType["NONE"] = "";
    MimeType["PDF"] = "application/pdf";
    MimeType["PNG"] = "image/png";
    MimeType["JPG"] = "image/jpeg";
    MimeType["WEBP"] = "image/webp";
    MimeType["GIF"] = "image/gif";
    MimeType["CSV"] = "text/csv";
    MimeType["TXT"] = "text/plain";
    MimeType["HTML"] = "text/html";
    MimeType["XML"] = "text/xml";
    MimeType["Markdown"] = "text/markdown";
    MimeType["JSON"] = "application/json";
    MimeType["RTF"] = "application/rtf";
    MimeType["ODT"] = "application/vnd.oasis.opendocument.text";
    MimeType["MSWordLegacy"] = "application/msword";
    MimeType["MSExcelLegacy"] = "application/vnd.ms-excel";
    MimeType["MSPowerPointLegacy"] = "application/vnd.ms-powerpoint";
    MimeType["MSWord"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MimeType["MSExcel"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MimeType["MSPowerPoint"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    MimeType["Zip"] = "application/zip";
})(MimeType || (MimeType = {}));
export const ALLOWED_DOCUMENT_MIME_TYPES = [
    MimeType.PDF,
    MimeType.PNG,
    MimeType.JPG,
    MimeType.WEBP,
    MimeType.CSV,
    MimeType.TXT,
    MimeType.MSWord,
    MimeType.MSWordLegacy,
    MimeType.MSExcel,
    MimeType.MSExcelLegacy,
];
export var DocumentOrigin;
(function (DocumentOrigin) {
    DocumentOrigin["Manager"] = "manager";
    DocumentOrigin["EmployeeApp"] = "employee_app";
    DocumentOrigin["API"] = "api";
    DocumentOrigin["Recruiting"] = "recruiting";
})(DocumentOrigin || (DocumentOrigin = {}));
export var JobPostingStatus;
(function (JobPostingStatus) {
    JobPostingStatus["Published"] = "published";
    JobPostingStatus["Archived"] = "archived";
})(JobPostingStatus || (JobPostingStatus = {}));
export var JobApplicationStatus;
(function (JobApplicationStatus) {
    JobApplicationStatus["Open"] = "open";
    JobApplicationStatus["Accepted"] = "accepted";
    JobApplicationStatus["Rejected"] = "rejected";
})(JobApplicationStatus || (JobApplicationStatus = {}));
export var BonusTypeMode;
(function (BonusTypeMode) {
    BonusTypeMode["Daily"] = "daily";
    BonusTypeMode["WeekDays"] = "weekdays";
    BonusTypeMode["Date"] = "date";
    BonusTypeMode["Holidays"] = "holidays";
})(BonusTypeMode || (BonusTypeMode = {}));
export var BonusLegalType;
(function (BonusLegalType) {
    BonusLegalType["Night1"] = "night1";
    BonusLegalType["Night2"] = "night2";
    BonusLegalType["Sunday"] = "sunday";
    BonusLegalType["Holiday"] = "holiday";
    BonusLegalType["Special"] = "special";
})(BonusLegalType || (BonusLegalType = {}));
export var BonusCompType;
(function (BonusCompType) {
    BonusCompType["ModifiedHourlyRate"] = "modified_hourly_rate";
    BonusCompType["FixedHourlyRate"] = "fixed_hourly_rate";
    BonusCompType["FixedAmount"] = "fixed_amount";
})(BonusCompType || (BonusCompType = {}));
// Partner-level permissions, granted per API client. Deliberately a separate namespace from the
// company-level scopes on APIAuthAccess/APIAuthToken. See docs/projects/gerl/partner-scopes.decision.md
export var PartnerScope;
(function (PartnerScope) {
    PartnerScope["CompanyCreate"] = "company:create";
    PartnerScope["AccountCreate"] = "account:create";
    /** DELETE /employees/{id}. */
    PartnerScope["EmployeeDelete"] = "employee:delete";
    /** POST /employees/{id}/retire. */
    PartnerScope["EmployeeRetire"] = "employee:retire";
})(PartnerScope || (PartnerScope = {}));
export const noteTypes = [
    "textNote", // contains only text with formatting options like bulleted lists, bold, italic
    "taskList", // contains only a checklist with checkboxes, text cannot be formatted
];
//# sourceMappingURL=model.types.js.map